import {Box, Typography} from '@mui/material';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

type Props = {
  ctaFinePrint?: string;
};

export const PricingText: React.FC<Props> = ({ctaFinePrint}) => {
  return ctaFinePrint ? (
    <Box sx={{fontSize: '16px', mb: '20px'}}>
      <ReactMarkdown
        rehypePlugins={[rehypeRaw as any]}
        children={ctaFinePrint}
      />
    </Box>
  ) : (
    <Typography variant="body1" mb="20px">
      7-day free trial, then <br />
      <Box component="span" fontWeight="bold">
        $139 per year
      </Box>{' '}
      ($11.58/month)
    </Typography>
  );
};
